<template>
	<div class="kudos-container rounded">
		<div class="kudos-overlay"></div>
		<v-img :src="kudos.image" class="rounded"/>
		<div class="txt" style="z-index: 2">
			<div class="type">{{ kudos.content }}</div>
			<div v-if="kudos.for_user" class="username mt-4">{{ kudos.for_user.name || kudos.for_user.email }}</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
	props: {
		post: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			kudos: null,
			type: null
		}
	},
	computed: {
		...mapGetters({
			types: 'dictionaries/kudosTypes'
		})
	},
	created() {
		if(this.post.postable) {
			this.kudos = this.post.postable;
			this.type = this.types.find(x => x.id == this.kudos.kudos_type_id)
		}
	}
}
</script>